import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {Store} from "@ngrx/store";
import * as fromStore from '../../store';
import {UserSubscription, UserSubscriptionCategory, UserSubscriptionType} from "../../user/user-subscription";
import {NavigationEnd, Router} from "@angular/router";
import {filter, first, switchMap, takeUntil} from "rxjs/operators";
import {User} from "../../user/user";
import {GoogleAnalyticsService} from "../../shared/services/google-analytics/google-analytics.service";
import {combineLatest, Subject} from "rxjs";
import {Utils} from "../../shared/utils/utils";

@Component({
    selector: 'db-white-label',
    templateUrl: './white-label.component.html',
    styleUrls: ['./white-label.component.scss'],
    standalone: false
})
export class WhiteLabelComponent implements OnInit, OnDestroy, AfterViewInit {
  public UserSubscriptionType: any = UserSubscriptionType;
  public UserSubscriptionCategory: any = UserSubscriptionCategory;
  public userSubscription: UserSubscription;
  public user: User;
  public dbTesting: boolean;
  public demoUser: boolean = false;
  public activeTab: string;
  public sidebarItems = [
    {
      label: 'WP Admin white labeling',
      routerLink: './wp-admin-white-label',
    },
    {
      label: 'Custom domain',
      routerLink: './custom-domain',
    },
    {
      label: 'Pre-installed plugins',
      routerLink: './pre-installed-plugins',
    }
  ];
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _router: Router,
    private _googleAnalyticsService: GoogleAnalyticsService,
  ) {
  }

  ngOnInit() {
    this._router.events
      .pipe(
        filter((event: any) => event instanceof NavigationEnd),
        takeUntil(this._destroyStream$)
      )
      .subscribe(() => {
        this.activeTab = this._router.url.split('/').pop() || 'custom-domain';;
      });
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        first((loaded: boolean) => loaded),
        switchMap(() => combineLatest(
            this._store.select(fromStore.getUser),
            this._store.select(fromStore.getUserSubscription)
          )
        ),
        takeUntil(this._destroyStream$)
      )
      .subscribe(([user, userSubscription]) => {
        this.user = user;
        this.userSubscription = userSubscription;
        this.demoUser = Utils.isDemoUser(userSubscription, user);
      });
  }

  ngAfterViewInit() {
    if (!this.userSubscription?.isAgency && this.userSubscription?.boosterCategory !== UserSubscriptionCategory.AGENCY) {
      setTimeout(() => {
        document.querySelector('.white-label__agency-banner-wrap').classList.add('animated');
      }, 500);
    }
  }

  ngOnDestroy() {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }

  redirectPricing() {
    this._router.navigate(['/upgrade-plan'], {queryParams: {active_tab: 'agency'}});
  }

}
